// Environment-based API URL configuration
const getServiceApiUrl = () => {
  // Use VITE_ENV if set (for staging/testing builds), otherwise fall back to MODE
  // Note: import.meta.env.MODE is "production" in production builds
  const env =
    import.meta.env.VITE_ENV || import.meta.env.MODE || "development";

  // Use environment to determine which environment variable to use
  switch (env) {
    case "production":
      return import.meta.env.VITE_API_BASE_URL_PRODUCTION;
    case "staging":
      return import.meta.env.VITE_API_BASE_URL_STAGING;
    case "testing":
      return import.meta.env.VITE_API_BASE_URL_TESTING;
    case "development":
    default:
      return import.meta.env.VITE_API_BASE_URL_LOCAL;
  }
};

const service_api = getServiceApiUrl();

export { service_api };
